import React, { useState } from "react";
import Cabecalho from "../../components/Cabecalho";
import Tabela from "../../components/TabelaClientes";
import { HStack } from "../../../../componentsv2/Stack";

export default function Clientes() {
  const [busca, setBusca] = useState("");

  return (
    <HStack>
      <Cabecalho busca={busca} setBusca={setBusca} />
      <Tabela busca={busca} />
    </HStack>
  );
}
